import RequestV2 from './request-v2';

export default class PaymentMethodHttpService {
    private static uri = 'payments/payment-method';

    public static createPaymentMethod(data: any) {
        return RequestV2.post(`${this.uri}`, data);
    }

    public static editPaymentMethod(data: any) {
        return RequestV2.put(`${this.uri}`, data);
    }

    public static deletePaymentMethod(id: number) {
        return RequestV2.del(`${this.uri}/${id}`);
    }
}
